import type { TOC } from '@ember/component/template-only';
import type { Signature as ProviderSig } from 'parog-web/components/forc/provider';

export default <template>
  <div class='field'>
    <@form.FieldsRadioGroup
      @title='Diagnostic principal'
      @translationKey='fur.mental-main-diag'
      @propertyName='mainDiagnosis'
      as |Group|
    >
      <Group.FieldRadio @value='bipolarDisorderType1' />
      <Group.FieldRadio @value='bipolarDisorderType2' />
      <Group.FieldRadio @value='cyclothimicDisorder' />
      <Group.FieldRadio @value='unknown' />
    </@form.FieldsRadioGroup>
  </div>
</template> satisfies TOC<{
  Args: {
    form: ProviderSig['Blocks']['content'][0];
  };
}>;
